import { Portal, Box, useDisclosure } from "@chakra-ui/react";
import Footer from "components/footer/FooterAdmin";
import Navbar from "components/navbar/NavbarAdmin";
import Sidebar from "components/sidebar/Sidebar";
import {
  SidebarContext,
  SIDEBAR_WIDTH_XL_COLLAPSED,
  SIDEBAR_WIDTH_XL_EXPANDED,
} from "contexts/SidebarContext";
import { useState, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import routes from "routes";

const partnerSidebarRoutes = routes.filter(
  (r) => r.layout === "/partner" && !r.hidden
);

export default function PartnerLayout(props: { [x: string]: any }) {
  const { ...rest } = props;
  const location = useLocation();
  const [fixed] = useState(true);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const sidebarReservePx = sidebarCollapsed
    ? SIDEBAR_WIDTH_XL_COLLAPSED
    : SIDEBAR_WIDTH_XL_EXPANDED;

  const { brandText, secondaryNav } = useMemo(() => {
    let name = "Dashboard";
    let secondary = false;
    for (let i = 0; i < routes.length; i++) {
      const r = routes[i];
      if (r.layout !== "/partner") continue;
      const pathPart = String(r.path).replace(/^\//, "");
      if (location.pathname.includes(pathPart)) {
        if (!r.hidden) name = r.name;
        secondary = Boolean((r as RoutesType).secondary);
      }
    }
    return { brandText: name, secondaryNav: secondary };
  }, [location.pathname]);

  const { onOpen } = useDisclosure();
  document.documentElement.dir = "ltr";

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
          sidebarCollapsed,
          setSidebarCollapsed,
        }}
      >
        <Sidebar routes={partnerSidebarRoutes} display="none" {...rest} />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{
            base: "100%",
            xl: `calc(100% - ${sidebarReservePx}px)`,
          }}
          maxW={{
            base: "100%",
            xl: `calc(100% - ${sidebarReservePx}px)`,
          }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box>
              <Navbar
                onOpen={onOpen}
                logoText="OnlyWine Partners"
                brandText={brandText}
                secondary={secondaryNav}
                message={brandText}
                fixed={fixed}
                sidebarCollapsed={sidebarCollapsed}
                {...rest}
              />
            </Box>
          </Portal>

          <Box
            mx="auto"
            p={{ base: "20px", md: "30px" }}
            pe="20px"
            minH="100vh"
            pt={{ base: "168px", md: "148px", xl: "100px" }}
          >
            <Outlet />
          </Box>
          <Box>
            <Footer />
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
